namespace com.enirva.geom
{
	/*
	 * Matrix3Dクラス (css3 matrix3d用)
	 */
	export class Matrix3D
	{
		public create():Float32Array
		{
			var m:Float32Array = new Float32Array(12);
			return m;
		}

		
		/*
		 * 単位行列化
		 */
		public identity(m:Float32Array):void
		{
			m[0] = 1;
			m[1] = 0;
			m[2] = 0;
			m[3] = 0;
			m[4] = 0;
			m[5] = 1;
			m[6] = 0;
			m[7] = 0;
			m[8] = 0;
			m[9] = 0;
			m[10] = 1;
			m[11] = 0;
		}


		/*
		 * X軸回転
		 */
		public rotationX(m:Float32Array, rad:number):void
		{
			var sin_rx = Math.sin(rad);
			var cos_rx = Math.cos(rad);

			m[5] = cos_rx;
			m[6] = sin_rx;
			m[9] = -sin_rx;
			m[10] = cos_rx;
		}


		/*
		 * Y軸回転
		 */
		public rotationY(m:Float32Array, rad:number):void
		{
			var sin_ry = Math.sin(rad);
			var cos_ry = Math.cos(rad);

			m[0] = cos_ry;
			m[2] = -sin_ry;
			m[8] = sin_ry;
			m[10] = cos_ry;
		}


		/*
		 * 拡大縮小（2D版）
		 */
		public scale(m:Float32Array, scaleX:number, scaleY:number):void
		{
			m[0] = scaleX;
			m[5] = scaleY;
		}


		/*
		 * 平行移動
		 */
		public translate(m:Float32Array, positions:number[]):void
		{
			m[3] = positions[0];
			m[7] = positions[1];
			m[11] = positions[2];
		}


		public multiply(m1:Float32Array, m2:Float32Array):void
		{
			var d11 = m1[0], d12 = m1[1], d13 = m1[2], d14 = m1[3];
			var d21 = m1[4], d22 = m1[5], d23 = m1[6], d24 = m1[7];
			var d31 = m1[8], d32 = m1[9], d33 = m1[10], d34 = m1[11];
			
			m1[0] = d11 * m2[0] + d12 * m2[4] + d13 * m2[8];
			m1[1] = d11 * m2[1] + d12 * m2[5] + d13 * m2[9];
			m1[2] = d11 * m2[2] + d12 * m2[6] + d13 * m2[10];
			m1[3] = d11 * m2[3] + d12 * m2[7] + d13 * m2[11] + d14;
			
			m1[4] = d21 * m2[0] + d22 * m2[4] + d23 * m2[8];
			m1[5] = d21 * m2[1] + d22 * m2[5] + d23 * m2[9];
			m1[6] = d21 * m2[2] + d22 * m2[6] + d23 * m2[10];
			m1[7] = d21 * m2[3] + d22 * m2[7] + d23 * m2[11] + d24;
			
			m1[8] = d31 * m2[0] + d32 * m2[4] + d33 * m2[8];
			m1[9] = d31 * m2[1] + d32 * m2[5] + d33 * m2[9];
			m1[10] = d31 * m2[2] + d32 * m2[6] + d33 * m2[10];
			m1[11] = d31 * m2[3] + d32 * m2[7] + d33 * m2[11] + d34;
		};


		public getTransformString(m:Float32Array):string
		{
			var enc = function(val) {
				return Math.round(val * 10000) / 10000;
			};
			var str = "matrix3d(";
			str += enc(m[0]) + ", " + enc(m[1]) + ", " + enc(m[2]) + ", 0, ";
			str += enc(m[4]) + ", " + enc(m[5]) + ", " + enc(m[6]) + ", 0, ";
			str += enc(m[8]) + ", " + enc(m[9]) + ", " + enc(m[10]) + ", 0, "; 
			str += enc(m[3]) + ", " + enc(m[7]) + ", " + enc(m[11]) + ", 1)"; 

			return str;
		}
	}
}

